import { render, staticRenderFns } from "./PromotionsTableV2.vue?vue&type=template&id=30865e05"
import script from "./PromotionsTableV2.vue?vue&type=script&lang=js"
export * from "./PromotionsTableV2.vue?vue&type=script&lang=js"
import style0 from "./PromotionsTableV2.vue?vue&type=style&index=0&id=30865e05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports